import { authAPI, getCachedAuthUser, getCachedAccessToken } from './api';

class UserBootstrapService {
  constructor() {
    this.cache = new Map();
  }

  getFromCache(key) {
    const entry = this.cache.get(key);
    if (!entry) return null;
    if (Date.now() - entry.ts > entry.ttl) {
      this.cache.delete(key);
      return null;
    }
    return entry.data;
  }

  setInCache(key, data, ttl = 15 * 1000) {
    this.cache.set(key, { data, ts: Date.now(), ttl });
  }

  async getUnified(forceRefresh = false) {
    const key = 'unified_me';
    if (!forceRefresh) {
      const hit = this.getFromCache(key);
      if (hit) return hit;
    }

    const cachedUser = getCachedAuthUser();
    const token = getCachedAccessToken();
    const userId = cachedUser?.id || null;

    const unified = await authAPI.getUnifiedMe({ userId, token });
    this.setInCache(key, unified);
    return unified;
  }

  clear() {
    this.cache.clear();
  }
}

const userBootstrapService = new UserBootstrapService();

export default userBootstrapService;
